// extracted by mini-css-extract-plugin
export var textInput = "_e0-0";